import { useMemo } from 'react';
import { Alert, SimpleGrid } from '@mantine/core';
import type { ComponentProjectMetricsResponse } from '../../../../types/dashboard';
import { SafeTClientAcquisitionComponentCard } from './SafeTClientAcquisitionComponentCard';
import { SafeTFacilityUtilizationCard } from './SafeTFacilityUtilizationCard';
import { SafeTRevenueBySubawardeeCard } from './SafeTRevenueBySubawardeeCard';
import { SafeTTulsaEmploymentCard } from './SafeTTulsaEmploymentCard';
import {
  hasSafeTClientAcquisitionData,
  hasSafeTFacilityUtilizationData,
  hasSafeTRevenueData,
  mapSafeTComponentProjectData,
} from './mapSafeTComponentProjectData';

type SafeTComponentProjectMetricsProps = {
  data: ComponentProjectMetricsResponse;
};

export function SafeTComponentProjectMetrics({ data }: SafeTComponentProjectMetricsProps) {
  const safeTData = useMemo(() => mapSafeTComponentProjectData(data), [data]);

  if (!safeTData) {
    return (
      <Alert color="blue" variant="light">
        No SAFE-T component project metrics are available yet.
      </Alert>
    );
  }

  const showClientAcquisition = hasSafeTClientAcquisitionData(safeTData);
  const showFacilityUtilization = hasSafeTFacilityUtilizationData(safeTData);
  const showRevenue = hasSafeTRevenueData(safeTData);

  return (
    <SimpleGrid
      cols={2}
      spacing="lg"
      breakpoints={[{ maxWidth: 1200, cols: 1 }]}
      sx={{ alignItems: 'stretch' }}
    >
      {showClientAcquisition ? (
        <SafeTClientAcquisitionComponentCard data={safeTData} />
      ) : null}
      {showRevenue ? <SafeTRevenueBySubawardeeCard data={safeTData} /> : null}
      <SafeTTulsaEmploymentCard data={safeTData} />
      {showFacilityUtilization ? (
        <SafeTFacilityUtilizationCard data={safeTData} />
      ) : null}
    </SimpleGrid>
  );
}
